import script from "./ProductUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductUpdate.vue?vue&type=script&setup=true&lang=js"

import "./ProductUpdate.vue?vue&type=style&index=0&id=66aef7bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66aef7bc"]])

export default __exports__